import { Injectable } from '@angular/core';
import { Actions, ofType } from '@ngrx/effects';
import * as ActionsList from './actions';
import { map, switchMap } from 'rxjs/operators';
import { createEffect } from '@ngrx/effects';
import { ToastrService } from 'ngx-toastr';
import { EPContributionService } from 'src/app/services/EmployerPortalServices/ep-contribution.service';

@Injectable()
export class ProcessedContributionEffects {
  constructor(private actions$: Actions,
    public toastr: ToastrService,
    private service: EPContributionService) {
  }

  getById$ = createEffect(() => this.actions$.pipe(
    ofType(ActionsList.RequestAction),
    switchMap((action: any) => this.service.getProcessedContribution(action.id)),
    map((data: any) => {
      return ActionsList.ResponseAction({ payload: data.data });
    })
  ));
}
